import { io, type Socket } from "socket.io-client";
import type {
  ServerToClientEvents,
  ClientToServerEvents,
} from "@shared/events";

export type TypedSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

export interface CreateSocketOptions {
  socketUrl?: string;
  token: string;
}

export function createSocket(opts: CreateSocketOptions): TypedSocket {
  const socket: TypedSocket = io(opts.socketUrl || "/", {
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 800,
    reconnectionDelayMax: 8000,
    reconnectionAttempts: Infinity,
    transports: ["websocket", "polling"],
    auth: { token: opts.token },
  });
  return socket;
}
